import { Model, Attr } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import { SorewardsProgramType } from '@/models/sorewardsProgramTypes'

@Model()
export default class SorewardsProgram extends ApplicationRecord {
  static jsonapiType = 'sorewards_programs'

  @Attr() id!: string
  @Attr({ persist: false }) sorewardsProgramId!: string
  @Attr() name!: string
  @Attr() programType!: SorewardsProgramType | ''
  @Attr({ persist: false }) createdAt!: string
  @Attr({ persist: false }) updatedAt!: string
}
